module.exports = __webpack_public_path__ + "img/icon-close-black.62ec80b6.svg";